export function aplicarMascara(value?: string) {
  if (value) {
    let cleanedValue = value.replace(/\D/g, '');
    // Apply phone mask: (99) 9999-9999 or (99) 9 9999-9999
    if (cleanedValue.length > 10) {
      return cleanedValue.replace(/(\d{2})(\d)(\d{4})(\d{4})/, '($1) $2 $3-$4');
    }
    return cleanedValue.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
  }
  return '';
}
